<template>
  <Dialog
    ref="dialogRef"
    :title="title"
    :visible="visible"
    @close="handleClose"
    animationName="zoom"
    customCls="@xs:w-[88%] h-[max-content] max-w-[380px] absolute top-0 bottom-0 m-auto right-0 left-0 text-[14px] font-medium rounded-[10px] bg-e-g-color-1"
  >
    <div class="p-[15px]">
      <div class="text-e-g-color-14 whitespace-break-spaces">
        {{ content }}
      </div>
      <div
        class="flex justify-center gap-x-[10px] text-[14px] font-bold text-e-g-color-14 h-[40px] mt-[20px]"
      >
        <button
          v-if="isCancel"
          class="bg-e-g-color-13 flex-1 h-full rounded-[8px]"
          @click="haneleCancel"
        >
          {{ cancelText }}
        </button>
        <button
          v-if="isConfirm"
          class="bg-e-linear-color-2 text-e-g-color-15 flex-1 h-full rounded-[8px]"
          @click="handleConfirm"
        >
          {{ confirmText }}
        </button>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { ref } from "vue";
import Dialog from "components/customUI/dialog/index.vue";

// Props定义
const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  content: {
    type: String,
    default: "",
  },
  cancelText: {
    type: String,
    default: "Cancel",
  },
  confirmText: {
    type: String,
    default: "Confirm",
  },
  visible: {
    type: Boolean,
    default: false,
  },
  close: {
    type: Function,
    default: () => {},
  },
  cancel: {
    type: Function,
    default: () => {},
  },
  confirm: {
    type: Function,
    default: () => {},
  },
  isCancel: {
    type: Boolean,
    default: true,
  },
  isConfirm: {
    type: Boolean,
    default: true,
  },
});

const dialogRef = ref();
const closeDialog = () => {
  dialogRef.value.handleClose();
};

// 事件定义
const emits = defineEmits(["close", "cancel", "confirm"]);

// 事件处理
const handleClose = () => {
  closeDialog();
  props.close();
  emits("close");
};
const haneleCancel = () => {
  closeDialog();
  props.cancel();
  emits("cancel");
};
const handleConfirm = () => {
  closeDialog();
  props.confirm();
  emits("confirm");
};
</script>
